import { useEffect } from 'react';
import { useAuthStore } from '../store/useAuthStore';
import { signInToFirebase, signOutFromFirebase, onFirebaseAuthStateChanged } from '../lib/firebase/authService';

export function useFirebaseAuth() {
  useEffect(() => {
    // Skip Firebase auth in WebView mode
    const urlParams = new URLSearchParams(window.location.search);
    const isWebView = urlParams.get('isWebView') === 'true' || window.location.pathname === '/webview';
    
    if (isWebView) {
      console.log('Skipping Firebase auth in WebView mode');
      return;
    }
    
    // Listen to auth state changes
    const unsubscribe = useAuthStore.subscribe((state, prevState) => {
      // User logged in
      if (state.accessToken && !prevState.accessToken) {
        signInToFirebase().then((user) => {
          if (user) {
            console.log('Firebase auth successful:', user.uid);
          } else {
            console.error('Firebase auth failed');
          }
        }).catch(console.error);
      } 
      // User logged out
      else if (!state.accessToken && prevState.accessToken) {
        signOutFromFirebase().catch(console.error);
      }
    });

    // Also check initial state
    const currentState = useAuthStore.getState();
    if (currentState.accessToken && !isWebView) {
      signInToFirebase().catch(console.error);
    }

    // Listen to Firebase auth state changes
    const unsubscribeFirebase = onFirebaseAuthStateChanged((user) => {
      if (user) {
       
      } else {
        console.log('Firebase user signed out');
      }
    });

    return () => {
      unsubscribe();
      unsubscribeFirebase();
    };
  }, []);
}